import { clsx } from "clsx";
import React from "react";
import Styles from "./PermissionOptions.module.css";
import PermissionStyles from "./ShareType.module.css";

export interface PermissionOptionProps extends ShareOptionValue {
  /** Whether or not the option button is enabled/disabled, i.e. clickable */
  disabled?: boolean;
  /** Add border to option to highlight */
  highlight?: boolean;
  /** Make the option look not selectable */
  inactive?: boolean;
  onClick?: () => void;
  /** The active option, filled w/ border */
  selected?: boolean;
}

export const PermissionOption = ({
  color,
  disabled,
  highlight,
  inactive,
  onClick,
  selected,
  title,
  tooltip,
}: PermissionOptionProps) => (
  <button
    className={clsx(
      Styles.permissionOption,
      color,
      inactive && "inactive",
      highlight && "highlight",
      selected && "selected",
    )}
    data-test-id={title}
    data-tooltip-class-name={clsx(color, PermissionStyles.tooltip)}
    data-tooltip-html={tooltip}
    data-tooltip-id="tooltip"
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    {title}
  </button>
);
